import { Icon } from '@chakra-ui/react'

export const EducationIcon = () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse
            cx="60"
            cy="60"
            rx="52"
            ry="52"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
        <path
            d="M90.6871 28.8365H62.1328V18H99.563C99.6318 18 99.7006 18 99.7694 18C105.618 18.138 110.365 22.9696 110.365 28.8365H97.9804"
            fill="#F6F6F6"
        />
        <path
            d="M90.6871 28.8365H62.1328V18H99.563C99.6318 18 99.7006 18 99.7694 18C105.618 18.138 110.365 22.9696 110.365 28.8365H97.9804H90.6871Z"
            stroke="#C3C3C3"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
        <path
            d="M100.595 18C98.3934 18.138 96.3292 19.0353 94.8843 20.5538C94.7467 20.6919 94.6091 20.8299 94.4715 21.037C93.1642 22.5555 92.2009 24.5571 92.2009 26.6968V91.1635C92.2009 97.1684 87.3845 102 81.3984 102H28.8311V26.2136C28.9687 24.0049 29.7943 22.0033 31.2392 20.5538C32.8218 18.9663 34.9547 18 37.3629 18H90.2743H100.32C100.389 18 100.458 18 100.595 18Z"
            fill="white"
            stroke="#C3C3C3"
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinejoin="round"
        />
        <path
            d="M81.7425 32.7704H66.1236C65.5732 32.7704 65.0916 32.2872 65.0916 31.735C65.0916 31.1829 65.5732 30.6997 66.1236 30.6997H81.7425C82.2929 30.6997 82.7746 31.1829 82.7746 31.735C82.7746 32.2872 82.3617 32.7704 81.7425 32.7704Z"
            fill="#959595"
        />
        <path
            d="M58.7613 32.7704H38.3949C37.8444 32.7704 37.3628 32.2872 37.3628 31.735C37.3628 31.1829 37.8444 30.6997 38.3949 30.6997H58.8301C59.3805 30.6997 59.8622 31.1829 59.8622 31.735C59.8622 32.2872 59.3805 32.7704 58.7613 32.7704Z"
            fill="#C3C3C3"
        />
        <path
            d="M71.8343 42.9862H51.5367C50.9863 42.9862 50.5046 42.503 50.5046 41.9509C50.5046 41.3987 50.9863 40.9155 51.5367 40.9155H71.8343C72.3848 40.9155 72.8664 41.3987 72.8664 41.9509C72.9352 42.503 72.4536 42.9862 71.8343 42.9862Z"
            fill="#959595"
        />
        <path
            d="M45.0002 42.9862H38.3949C37.8444 42.9862 37.3628 42.503 37.3628 41.9509C37.3628 41.3987 37.8444 40.9155 38.3949 40.9155H45.0002C45.5506 40.9155 46.0323 41.3987 46.0323 41.9509C46.0323 42.503 45.5506 42.9862 45.0002 42.9862Z"
            fill="#C3C3C3"
        />
        <path
            d="M81.7425 53.201H69.2887C68.7382 53.201 68.2566 52.7179 68.2566 52.1657C68.2566 51.6135 68.7382 51.1304 69.2887 51.1304H81.7425C82.2929 51.1304 82.7746 51.6135 82.7746 52.1657C82.7746 52.7179 82.3617 53.201 81.7425 53.201Z"
            fill="#C3C3C3"
        />
        <path
            d="M63.3025 53.201H38.3949C37.8444 53.201 37.3628 52.7179 37.3628 52.1657C37.3628 51.6135 37.8444 51.1304 38.3949 51.1304H63.3025C63.8529 51.1304 64.3345 51.6135 64.3345 52.1657C64.3345 52.7179 63.9217 53.201 63.3025 53.201Z"
            fill="#959595"
        />
        <path
            d="M71.8345 63.4164H58.1422C57.5917 63.4164 57.1101 62.9332 57.1101 62.381C57.1101 61.8289 57.5917 61.3457 58.1422 61.3457H71.8345C72.3849 61.3457 72.8666 61.8289 72.8666 62.381C72.9354 62.9332 72.4537 63.4164 71.8345 63.4164Z"
            fill="#959595"
        />
        <path
            d="M52.156 63.4164H38.3949C37.8444 63.4164 37.3628 62.9332 37.3628 62.381C37.3628 61.8289 37.8444 61.3457 38.3949 61.3457H52.2248C52.7752 61.3457 53.2569 61.8289 53.2569 62.381C53.2569 62.9332 52.7752 63.4164 52.156 63.4164Z"
            fill="#C3C3C3"
        />
        <path
            d="M81.7423 73.6317H72.1783C71.6279 73.6317 71.1462 73.1485 71.1462 72.5964C71.1462 72.0442 71.6279 71.561 72.1783 71.561H81.7423C82.2927 71.561 82.7744 72.0442 82.7744 72.5964C82.7744 73.1485 82.3615 73.6317 81.7423 73.6317Z"
            fill="#959595"
        />
        <path
            d="M65.9859 73.6317H49.9542C49.4038 73.6317 48.9221 73.1485 48.9221 72.5964C48.9221 72.0442 49.4038 71.561 49.9542 71.561H65.9859C66.5363 71.561 67.018 72.0442 67.018 72.5964C67.018 73.1485 66.5363 73.6317 65.9859 73.6317Z"
            fill="#C3C3C3"
        />
        <path
            d="M43.9681 73.6317H38.3949C37.8444 73.6317 37.3628 73.1485 37.3628 72.5964C37.3628 72.0442 37.8444 71.561 38.3949 71.561H43.9681C44.5186 71.561 45.0002 72.0442 45.0002 72.5964C45.0002 73.1485 44.5186 73.6317 43.9681 73.6317Z"
            fill="#959595"
        />
        <path
            d="M71.8344 83.847H62.3392C61.7888 83.847 61.3071 83.3639 61.3071 82.8117C61.3071 82.2595 61.7888 81.7764 62.3392 81.7764H71.8344C72.3848 81.7764 72.8664 82.2595 72.8664 82.8117C72.9353 83.3639 72.4536 83.847 71.8344 83.847Z"
            fill="#959595"
        />
        <path
            d="M56.0779 83.847H38.3949C37.8444 83.847 37.3628 83.3639 37.3628 82.8117C37.3628 82.2595 37.8444 81.7764 38.3949 81.7764H56.0779C56.6283 81.7764 57.11 82.2595 57.11 82.8117C57.11 83.3639 56.6283 83.847 56.0779 83.847Z"
            fill="#C3C3C3"
        />
        <path
            d="M58.2797 93.4414H72.1784C72.1784 95.7882 73.1417 97.9278 74.6554 99.4463C76.1692 101.034 78.3021 101.931 80.6415 101.931H18.0973C15.758 101.931 13.625 100.965 12.1113 99.4463C10.5976 97.9278 9.63428 95.7882 9.63428 93.4414H50.7799C50.7799 93.4414 58.4173 93.5104 58.2797 93.4414Z"
            fill="#F6F6F6"
            stroke="#C3C3C3"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
        <path
            d="M106.425 96.0155L97.7983 87.3956L99.776 85.418L108.396 94.0447L106.425 96.0155Z"
            fill="#C3C3C3"
            stroke="#959595"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
        <path
            d="M109.424 99.0484L102.809 92.4334C102.256 91.881 102.256 90.9808 102.809 90.4284C103.361 89.8761 104.261 89.8761 104.814 90.4284L111.429 97.0434C111.981 97.5958 111.981 98.496 111.429 99.0484C110.876 99.6007 109.976 99.6007 109.424 99.0484Z"
            fill="#9B9B9B"
        />
        <path
            d="M108.953 99.4715L100.443 90.9607C100.245 90.7629 100.245 90.4424 100.443 90.2378L102.618 88.0624C102.816 87.8646 103.136 87.8646 103.341 88.0624L111.852 96.5732C112.049 96.7709 112.049 97.0915 111.852 97.2961L109.676 99.4715C109.472 99.6693 109.151 99.6693 108.953 99.4715Z"
            fill="#C3C3C3"
            stroke="#959595"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
        <path
            d="M88.0327 59.6196C79.0037 59.6196 71.6863 66.937 71.6863 75.9661C71.6863 84.9883 79.0037 92.3125 88.0259 92.3125C97.055 92.3125 104.372 84.9952 104.372 75.9661C104.372 66.937 97.055 59.6196 88.0327 59.6196ZM88.0327 89.2847C80.7836 89.2847 74.9119 83.3176 74.9119 75.9593C74.9119 68.601 80.7836 62.6407 88.0327 62.6407C95.2819 62.6407 101.154 68.6078 101.154 75.9661C101.154 83.3244 95.2751 89.2847 88.0327 89.2847Z"
            fill="#C3C3C3"
            stroke="#959595"
            strokeWidth="1.25"
            strokeMiterlimit="10"
        />
    </svg>
)
